import { render } from "./ChannelGoalEnd.vue?vue&type=template&id=6d95083c"
import script from "./ChannelGoalEnd.vue?vue&type=script&lang=ts"
export * from "./ChannelGoalEnd.vue?vue&type=script&lang=ts"
script.render = render

export default script